import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['map', 'current', 'branch', 'location'];

  connect() {
    if (window.ymaps) {
      this.initMap();
    } else {
      this.loadScript();
    }
  }

  loadScript() {
    let script = document.createElement('script');
    const prior = document.getElementsByTagName('script')[0];
    script.async = 1;

    script.onload = script.onreadystatechange = (_, isAbort) => {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if (!isAbort) {
          this.initMap();
        }
      }
    };

    script.src = 'https://api-maps.yandex.ru/2.1/?lang=ru_RU&csp=true';
    prior.parentNode.insertBefore(script, prior);
  }

  initMap() {
    let controller = this;

    // debugger;
    ymaps.ready(() => {
      const map = new ymaps.Map(this.mapTarget.id, {
        center: [this.branchTarget.dataset.latitude, this.branchTarget.dataset.longitude],
        zoom: this.branchTarget.dataset.zoom
      });
      map.controls.add('zoomControl', { top: 75, left: 5 });
      map.behaviors.disable('scrollZoom');
      map.controls.remove('searchControl');

      const boundsCollection = new ymaps.GeoObjectCollection();

      controller.locationTargets.forEach((location) => {
        const placemark = new ymaps.Placemark(
          [location.dataset.latitude, location.dataset.longitude],
          {
            balloonContentHeader: location.dataset.name,
            balloonContentBody: `Предполагаемое местоположение пользователя ${location.dataset.name}`,
            hintContent: location.dataset.name
          },
          {
            openEmptyBalloon: true,
            preset: `islands#${location.dataset.color}CircleIcon`
          }
        );

        boundsCollection.add(placemark);

      });

      const current = this.currentTarget;
      const current_placemark = new ymaps.Placemark(
        [current.dataset.latitude, current.dataset.longitude],
        {
          balloonContentHeader: current.dataset.name,
          balloonContentBody: 'Текущее предполагаемое местоположение',
          hintContent: current.dataset.name
        },
        {
          openEmptyBalloon: true,
          preset: `islands#${current.dataset.color}PersonCircleIcon`
        }
      );

      boundsCollection.add(current_placemark);

      const branch = new ymaps.Placemark(
        [this.branchTarget.dataset.latitude, this.branchTarget.dataset.longitude],
        {
          hintContent: `Филиал: ${this.branchTarget.dataset.city}`
        },
        {
          preset: 'islands#redHomeCircleIcon'
        }
      );

      boundsCollection.add(branch);

      // debugger;
      map.geoObjects.add(boundsCollection);
      //map.setBounds(boundsCollection.getBounds());

      this.map = map;

    });
  }

}
